export function seededRandom(seed: number): () => number {
  return function () {
    seed = (seed * 9301 + 49297) % 233280;
    return seed / 233280;
  };
}

export function generateSeed(carId: string, date: Date = new Date()): number {
  const dateStr = date.toISOString().split('T')[0]; // YYYY-MM-DD
  const combinedStr = `${carId}-${dateStr}`;
  let hash = 0;

  for (let i = 0; i < combinedStr.length; i++) {
    hash = (hash << 5) - hash + combinedStr.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return Math.abs(hash);
}

export function getRandomIndices(
  arrayLength: number,
  count: number,
  seed: number,
): number[] {
  if (count > arrayLength || !arrayLength) {
    return [];
  }

  const random = seededRandom(seed);
  const indices = new Set<number>();

  while (indices.size < count) {
    const randomIndex = Math.floor(random() * arrayLength);
    indices.add(randomIndex);
  }
  return Array.from(indices);
}
